export default {
  methods: {
    async downloadImage(imageSrc, name) {
      const image = await fetch(imageSrc, {mode: 'cors'});
      const imageBlog = await image.blob();
      const imageURL = URL.createObjectURL(imageBlog);

      const link = document.createElement('a');
      link.href = imageURL;
      link.download = name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    downloadFile(data) {
      const link = document.createElement('a');
      link.href = data;
      link.download = 'name';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    downloadPdf(pdf, name = 'pdf.pdf') {
      const blob = new Blob([pdf.data], {type: "application/pdf"});
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = name;
      link.click();
    }
  }
}
